import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { firstNameSchema, lastNameSchema } from '@entities/fio-fields/model';

import { onlyCyrillic, onlyLetters, phoneRegEx } from '@shared/regexps';

import type { RelativeDetails } from '../../../api';
import { RECORDS_PER_FORM_MAX, RECORDS_PER_FORM_MIN } from '../../constants';

const requiredMessage = i18n.t('COMMON:errors.required');

const middleNameSchema = yup
  .string()
  .max(50, i18n.t('COMMON:errors.maxLength'))
  .matches(onlyLetters, {
    excludeEmptyString: true,
    message: i18n.t('COMMON:errors.middleNameStartWithLetter'),
  })
  .matches(onlyCyrillic, {
    excludeEmptyString: true,
    message: i18n.t('COMMON:errors.useCyrillic'),
  });

const relationshipTypes: RelativeDetails['relationshipType'][] = [
  'FATHER',
  'MOTHER',
  'BROTHER',
  'SISTER',
  'SPOUSE',
  'CHILD',
];

const relationshipRequiredMessage = i18n.t(
  'REGISTRATION_QUESTIONARY:rgsEmployeeRelativesForm.errors.relationship'
);

export const stepRgsRelativesSchema = yup
  .object({
    relativesDetails: yup
      .array()
      .of(
        yup
          .object({
            relationshipType: yup
              .mixed<RelativeDetails['relationshipType']>()
              .oneOf(relationshipTypes, relationshipRequiredMessage)
              .required(relationshipRequiredMessage),
            lastName: lastNameSchema,
            firstName: firstNameSchema,
            middleName: middleNameSchema,
            birthDate: yup.string().required(requiredMessage),
            phone: yup
              .string()
              .required(requiredMessage)
              .matches(
                phoneRegEx,
                i18n.t('COMMON:errors.incorrectPhoneNumber')
              ),
          })
          .required()
      )
      .required(requiredMessage)
      .min(RECORDS_PER_FORM_MIN, requiredMessage)
      .max(RECORDS_PER_FORM_MAX),
  })
  .required();
